export default __webpack_public_path__ + "static/media/servicetype_pd.d5518b21.png";